// Mirrors edge/services/matchNights.js MATCH_NIGHT_REGION /
// SERVER_LOCATIONS_BY_REGION / MATCH_NIGHT_STATUS. The backend list is the
// source of truth for validation; kept in sync manually, same pattern as
// marketing lead regions.

export const REGION_OPTIONS = [
  { value: "EU", label: "EU" },
  { value: "NA", label: "NA" },
];

export const SERVER_LOCATIONS_BY_REGION = {
  EU: [
    { value: "frankfurt", label: "Frankfurt" },
    { value: "london", label: "London" },
  ],
  NA: [{ value: "ohio", label: "Ohio" }],
};

// Representative IANA zones for wall-clock input/display. Mirrors
// edge/services/matchNightTime.js REGION_TIME_ZONES.
export const REGION_TIME_ZONES = {
  EU: { timeZone: "Europe/Berlin", abbreviation: "CET" },
  NA: { timeZone: "America/New_York", abbreviation: "ET" },
};

export function getRegionTimeZone(region) {
  return REGION_TIME_ZONES[region] || REGION_TIME_ZONES.EU;
}

export const STATUS_LABELS = {
  draft: "Draft",
  published: "Published",
  live: "Live",
  completed: "Completed",
  cancelled: "Cancelled",
};

export function getServerLocationLabel(value) {
  for (const region of Object.keys(SERVER_LOCATIONS_BY_REGION)) {
    const found = SERVER_LOCATIONS_BY_REGION[region].find((loc) => loc.value === value);
    if (found) return found.label;
  }
  return value;
}
